export const getFirstLetter = (text: string) => {
  if (!text) {
    return '';
  }
  return text[0];
};

export const capitalize = (text: string): string =>
  `${text.charAt(0).toUpperCase()}${text.slice(1)}`;
